export type BatchSummary = {
  id: string;
  batch_id: string;
  created_at: string;
  user_count: number;
  amount: number;
  category: string;
  reason: string;
  succeeded: number;
  failed: number;
  reversed: boolean;
};

export type ReverseResultRow = {
  user_id: string;
  original_grant_id: string;
  ok: boolean;
  skipped?: "already_reversed";
  ledger_id?: string;
  balance_after?: number;
  error?: string;
};

export type ReverseResponse = {
  ok?: boolean;
  batch_id?: string;
  attempted?: number;
  succeeded?: number;
  skipped_already_reversed?: number;
  failed?: number;
  results?: ReverseResultRow[];
  error?: string;
};

export const fmtBatchDate = (iso: string) => new Date(iso).toLocaleString();
